<template>
  <b-container class="root-container">
    <b-form-group id="grp_txt_username" label="Username:" label-for="txt_username" label-size="sm">
      <b-form-input id="txt_username" type="text" required placeholder v-model="username"></b-form-input>
    </b-form-group>

    <b-form-group id="grp_txt_password" label="Password:" label-for="txt_password" label-size="sm">
      <b-form-input id="txt_password" type="password" required placeholder v-model="password"></b-form-input>
    </b-form-group>
    
    <b-button class="mt-2 float-right" type="submit" variant="primary" @click="login()">Login</b-button>
  </b-container>
</template>

<script>
export default {
  name: "Login",
  inject: ["API_HOST", "is_login"],
  data() {
    return {
      username: "",
      password: "",
      eventHub : window.eventHub
    };
  },
  methods: {

    async login() {
      if (this.username == "" || this.password == "") {
        alert("Please enter username & password");
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "login.php",
        data: {
          username: this.username,
          password: this.password
        }
      });

      if (response.data.status == "success") {
        localStorage.setItem("user_obj", JSON.stringify({
          user_id: response.data.user.id,
          user_name: response.data.user.username,
          account_type: response.data.user.account_type,
          name: response.data.user.name,
          permissions: response.data.user.permissions,
          sys_permissions: response.data.user.sys_permissions,
          client_id: response.data.user.client_id,
          first_time_login : response.data.user.first_time_login,
        }));
        // this.is_login = true;

        this.$store.state.user_obj = {
          user_id: response.data.user.id,
          user_name: response.data.user.username,
          account_type: response.data.user.account_type,
          name: response.data.user.name,
          permissions: response.data.user.permissions,
          sys_permissions: response.data.user.sys_permissions,
          client_id: response.data.user.client_id,
          first_time_login : response.data.user.first_time_login,
        };

        eventHub.$emit('user_login');
        if(response.data.user.first_time_login == '1'){
          this.$router.replace("/account_password_change");
        }else if(response.data.user.init_page && response.data.user.init_page != ''){
          this.$router.replace(response.data.user.init_page);
        }else if(response.data.user.account_type == 'hkt_admin'){
          this.$router.replace("/hkt_orders");
        }else if(response.data.user.account_type == 'sleb_admin'){
          this.$router.replace("/cms_report");
        }else if(response.data.user.account_type == 'sleb_regional'){
          this.$router.replace("/cms_report");
        }else if(response.data.user.account_type == 'sleb_hotel'){
          this.$router.replace("/cms_report");
        }else if(response.data.user.account_type == 'gols_cs'){
          this.$router.replace("/cms_report");
        }else if(response.data.user.account_type == 'cpr_admin'){
          this.$router.replace("/cpr_orders");
        }else if(response.data.user.account_type == 'vendor' || response.data.user.account_type == 'vendor_warehouse'){
          this.$router.replace("/vendor_orders");
        }else if(response.data.user.account_type == 'warehouse'){
          this.$router.replace("/fulfillment_process_v2");
        }else if(response.data.user.account_type == 'route'){
          this.$router.replace("/route_allocation");
        }else if(response.data.user.account_type == 'redemption_center'){
          this.$router.replace("/redemption_center");
        }else if(response.data.user.account_type == 'driver_route'){
          this.$router.replace("/route_allocation");
        }else if(response.data.user.account_type == 'driver_route_whole'){
          this.$router.replace("/route_allocation");
        }else{
          this.$router.replace("/order_master");
        }
      } else {
        alert("Incorrect username / password");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.root-container{
  padding-top: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue